<template>
  <div class="flex w-full grow flex-col items-center p-16">
    <div class="w-full grow space-y-24 lg:max-w-[57rem]">
      <ClaimInfoSkeleton />
      <MessageSkeleton v-for="skeleton in messageSkeletonNum" :key="skeleton" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ClaimInfoSkeleton from '../ClaimInfo/ClaimInfoSkeleton.vue'
import MessageSkeleton from '../Message/MessageSkeleton.vue'

defineProps<{
  messageSkeletonNum: number
}>()
</script>
